export default __webpack_public_path__ + "static/giga_logo-7dd73cdd4e8486cb5dd2f5511b461a3d.jpg";